import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import { api, errMsg } from "./lib/api";
import Shell from "./components/Shell";
import Auth from "./pages/Auth";
import Overview from "./pages/Overview";
import Accounts, { ctraderRedirectUri } from "./pages/Accounts";
import Performance from "./pages/Performance";
import Sharing from "./pages/Sharing";
import Affiliate from "./pages/Affiliate";
import EARental from "./pages/EARental";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminPayments from "./pages/admin/AdminPayments";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminWithdrawals from "./pages/admin/AdminWithdrawals";
import AdminEA from "./pages/admin/AdminEA";
import Security from "./pages/Security";
import Profile from "./pages/Profile";
import AdminRentals from "./pages/admin/AdminRentals";

const captureReferral = () => {
  const ref = new URLSearchParams(window.location.search).get("ref");
  if (!ref) return;
  localStorage.setItem("tp_ref", ref.toUpperCase());
  api.post(`/affiliates/click/${ref}`).catch(() => {});
  window.history.replaceState({}, "", "/");
};

function App() {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [page, setPage] = useState("overview");
  const [data, setData] = useState(null);
  const [notice, setNotice] = useState("");
  const [flash, setFlash] = useState("");

  const refresh = useCallback(() => api.get("/overview").then((r) => setData(r.data)), []);

  useEffect(() => {
    if (!flash) return undefined;
    const t = setTimeout(() => setFlash(""), 7000);
    return () => clearTimeout(t);
  }, [flash]);

  const loadMe = useCallback(() => api.get("/me").then((r) => setUser(r.data)), []);

  useEffect(() => {
    captureReferral();
    const vt = window.location.pathname === "/verify-email" && new URLSearchParams(window.location.search).get("token");
    if (vt) {
      window.history.replaceState({}, "", "/");
      api.post("/auth/verify-email", { token: vt })
        .then((r) => { setFlash(r.data.message); if (localStorage.getItem("tp_token")) loadMe(); })
        .catch((e) => setFlash(errMsg(e, "Verifikasi gagal.")));
    }
    if (!localStorage.getItem("tp_token") || window.location.pathname === "/reset-password") { setReady(true); return; }
    api.get("/me").then((r) => setUser(r.data)).catch(() => localStorage.removeItem("tp_token")).finally(() => setReady(true));
  }, []);

  useEffect(() => {
    if (!user) return undefined;
    refresh();
    const code = window.location.pathname === "/ctrader/callback" && new URLSearchParams(window.location.search).get("code");
    if (code) {
      window.history.replaceState({}, "", "/");
      setPage("accounts");
      api.post("/brokers/ctrader/exchange", { code, redirect_uri: ctraderRedirectUri() })
        .then((r) => setNotice(`cTrader terhubung: ${r.data.added} akun baru ditambahkan.`))
        .catch((e) => setNotice(errMsg(e, "Otorisasi cTrader gagal.")));
    }
    const t = setInterval(refresh, 60000);
    return () => clearInterval(t);
  }, [user, refresh]);

  if (!ready) return null;
  if (!user) return <Auth onAuth={setUser} flash={flash} />;
  const logout = () => { localStorage.removeItem("tp_token"); setUser(null); setData(null); setPage("overview"); };
  const isAdmin = user.role === "admin";

  const pages = {
    overview: <Overview data={data} user={user} go={setPage} />,
    accounts: <Accounts key={notice} notice={notice} refreshOverview={refresh} />,
    performance: <Performance data={data} />,
    sharing: <Sharing />,
    affiliate: <Affiliate />,
    ea: <EARental />,
    profile: <Profile user={user} onUser={setUser} />,
    security: <Security user={user} onTokenRotated={loadMe} />,
    ...(isAdmin && { "admin-overview": <AdminOverview go={setPage} />, "admin-payments": <AdminPayments />, "admin-settings": <AdminSettings />, "admin-withdrawals": <AdminWithdrawals />, "admin-ea": <AdminEA />, "admin-rentals": <AdminRentals /> }),
  };

  return <Shell user={user} page={page} setPage={setPage} onLogout={logout} flash={flash}>{pages[page] || pages.overview}</Shell>;
}

export default App;
